
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M18.977 4H4.713a.67.67 0 00-.597.364.68.68 0 00.052.707l5.226 7.362.006.007c.19.257.292.567.293.886v6.002a.668.668 0 00.93.62l2.937-1.12c.263-.08.437-.33.437-.628v-4.874c0-.319.104-.63.293-.886l.006-.007 5.226-7.362a.679.679 0 00.053-.707.67.67 0 00-.598-.364z","fill-rule":"nonzero"}})])
          )
        }
      }
    